import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { Controller } from 'react-hook-form';
import CustomDateInputField from './CustomDateInputField';
import CustomTimeInputField from './CustomTimeInputField';

const onDateChange = ({ momentDate, field, utils }) => {
  if (momentDate && utils.isValid(momentDate)) {
    field.onChange(momentDate);
  }
};

const StartingDate = ({ fromDate, toDate, control, labels, utils }) => (
  <Box sx={{ p: 1 }}>
    <FormControl variant="standard" fullWidth>
      <InputLabel shrink htmlFor="starting-date">
        {labels.startingDate || 'Starting Date'}
      </InputLabel>
      <Controller
        render={({ field }) => (
          <CustomDateInputField
            {...field}
            maxDate={toDate}
            size="small"
            id="starting-date"
            format="YYYY-MM-DD"
            value={fromDate}
            onChange={momentTo => onDateChange({ momentDate: momentTo, field, utils })}
          />
        )}
        name={'fromDate'}
        control={control}
      />
    </FormControl>
    <Box sx={{ mt: 1 }}>
      <Controller
        render={({ field }) => (
          <DateCalendar
            {...field}
            maxDate={toDate}
            value={fromDate}
            onChange={momentTo => onDateChange({ momentDate: momentTo, field, utils })}
            sx={{ backgroundColor: 'surface.2', borderRadius: '5px' }}
          />
        )}
        name={'fromDate'}
        control={control}
      />
    </Box>
    <FormControl variant="standard" fullWidth sx={{ mt: 1 }}>
      <InputLabel shrink htmlFor="starting-time">
        {labels.startingTime || 'Starting Time'}
      </InputLabel>
      <Controller
        render={({ field }) => (
          <CustomTimeInputField
            {...field}
            value={fromDate}
            maxTime={toDate}
            ampm={false}
            size="small"
            id="starting-time"
            onChange={momentFrom => {
              if (momentFrom && utils.isValid(momentFrom)) {
                field.onChange(momentFrom);
              }
            }}
          />
        )}
        name={'fromDate'}
        control={control}
      />
    </FormControl>
  </Box>
);

export default StartingDate;
